import React, { useCallback, useEffect, useRef, useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button, Card } from "@heroui/react";
import { FormattedMessage } from "react-intl";
import { createPortal } from "react-dom";

export function ReloadPrompt() {
    const [isVisible, setIsVisible] = useState(false);
    const isInitialLoad = useRef(true);

    const reloadSW = import.meta.env.PROD === true;

    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, reg) {
            if (reloadSW) {
                if (!reg) {
                    return;
                }

                setInterval(async () => {
                    // console.debug("Checking for sw update");
                    const res = await reg.update();
                    // console.log("sw update res", res);
                }, 60000);
            } else {
            }
        },
        onRegisterError(error) {},
    });

    const close = useCallback(() => {
        setIsVisible(false);
        setNeedRefresh(false);
    }, [setNeedRefresh]);

    const handleUpdate = useCallback(() => {
        updateServiceWorker(true).finally(() => window.location.reload());
        setIsVisible(false);
    }, [updateServiceWorker]);

    useEffect(() => {
        const timer = setTimeout(() => {
            isInitialLoad.current = false;
        }, 3000); // 3 seconds grace period

        return () => clearTimeout(timer);
    }, []);

    // Logic Effect: Handle the needRefresh trigger
    useEffect(() => {
        if (!needRefresh) {
            setIsVisible(false);
            return;
        }

        if (isInitialLoad.current) {
            setNeedRefresh(false);
            return;
        }

        setIsVisible(true);
    }, [needRefresh, setNeedRefresh]);

    if (!isVisible) {
        return null;
    }

    const cardComponent = (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-[500px] px-4">
            <Card>
                <Card.Content className="flex flex-col gap-4">
                    <p className="text-center">
                        <FormattedMessage id="app.global.binaleNeedUpdate" tagName="span" />
                    </p>
                    <div className="flex gap-2 justify-end">
                        <Button variant="outline" onPress={close}>
                            <FormattedMessage id="app.button.close" />
                        </Button>
                        <Button onPress={handleUpdate}>
                            <FormattedMessage id="app.button.update" />
                        </Button>
                    </div>
                </Card.Content>
            </Card>
        </div>
    );

    return createPortal(cardComponent, document.body);
}
